import {
	Button,
	HStack,
	Input,
	Text,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { DEVELOPER_API_ROUTE } from 'apiRoutes';
import useSubmit, { POST } from 'hooks/useSubmit';
import { FunctionComponent, useState } from 'react';
import { RequestStatus } from 'types/RequestStatus';

const PurgeCachedPermissionsByApplication: FunctionComponent = () => {
	const [applicationId, setApplicationId] = useState<string>('');

	const [purgeCachedPermissions, status] = useSubmit(
		`${DEVELOPER_API_ROUTE}/PurgeCachedPermissionsByApplication`,
		POST,
		{
			messageOnError: 'An error occurred while purging permissions.',
			messageOnSuccess: 'Permissions purged successfully.',
			showApiError: true,
		},
	);

	const onPurgeCachedPermissions = () => {
		purgeCachedPermissions({ applicationId: applicationId });
	};

	return (
		<VStack>
			<Text>Purge cached permissions by application</Text>
			<HStack wrap="nowrap">
				<Input
					label="Application ID"
					type="text"
					autoComplete="off"
					name="applicationId"
					value={applicationId}
					required
					onChange={(event) => setApplicationId(event.target.value)}
				/>
			</HStack>
			<Button
				onClick={onPurgeCachedPermissions}
				type="submit"
				text="Purge cached permissions"
				loadingText="Purging permissions ..."
				isLoading={status === RequestStatus.LOADING}
				isDisabled={!applicationId.trim().length}
			/>
		</VStack>
	);
};

export default PurgeCachedPermissionsByApplication;
